<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="333"
      border
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('INDEX.table_label_expense_item') || '费用明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:expense="{ row }">
        <expense-select
          v-model="row.expenseCode"
          filterable
          clearable
          :body="{ expenseBizType: 'A' }"
          @change="
            (value, item) => expenseChange({ val: { value, item }, row })
          "
          size="mini"
        />
      </template>
      <template v-slot:customer="{ row }">
        <dict-select
          v-model="row.custCode"
          :selectedLabel.sync="row.custName"
          url="/master/common/dict/customerSelect"
          filterable
          clearable
          size="mini"
        ></dict-select>
      </template>
      <template v-slot:custOrderNo="{ row }">
        <OrderSelect
          :orderCode.sync="row.orderCode"
          :custOrderNo.sync="row.custOrderNo"
          :custCode="row.custCode"
          size="mini"
        />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import OrderSelect from '@/views/digital/components/order-select'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  components: { OrderSelect },
  props: {
    disabled: { type: Boolean, default: false },
    userBizContactFormCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      validRules: {
        expenseName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        currencyAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('INDEX.tips_input_cannot_be_zero') || '费用金额须大于0',
          },
        ],
        custName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.userBizContactFormCode) return
      this.$api
        .userBizContactFormItemListApi({
          userBizContactFormCode: this.userBizContactFormCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt({}, -1)
      await $itemTable.setActiveCell(newRow, 'currencyAmount')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.subTotAmount()
    },
    async subTotAmount() {
      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      this.$emit('updateTotAmount', totAmount)
    },
    expenseChange({ val, row }) {
      const { item } = val || {}
      const { expenseCode, expenseName, expenseType, v_expenseType } =
        item || {}
      row.expenseCode = expenseCode
      row.expenseName = expenseName
      row.expenseType = expenseType
      row.v_expenseType = v_expenseType
    },
  },
}
</script>
